import {doRequest} from '../../../helpers/network';
import {REQUEST_TYPE} from '../../../constants';
import {Revenue} from '../../../helpers/Urls';

const INITIAL_STATE = {
  addingConfig: false,
  fetchingCustomerInvoiceConfigs: false,
};

const FETCH_INITIAL_INVOICE_CUSTOMERS = 'FETCH_INITIAL_INVOICE_CUSTOMERS';
const FETCH_INITIAL_INVOICE_CUSTOMERS_COMPLETED =
  'FETCH_INITIAL_INVOICE_CUSTOMERS_COMPLETED';
const FETCH_INITIAL_INVOICE_CUSTOMERS_FAILED =
  'FETCH_INITIAL_INVOICE_CUSTOMERS_FAILED';

const ADD_CUSTOMER_INVOICE_CONFIG = 'ADD_CUSTOMER_INVOICE_CONFIG';
const ADD_CUSTOMER_INVOICE_CONFIG_COMPLETED =
  'ADD_CUSTOMER_INVOICE_CONFIG_COMPLETED';
const ADD_CUSTOMER_INVOICE_CONFIG_FAILED = 'ADD_CUSTOMER_INVOICE_CONFIG_FAILED';

const GET_CUSTOMER_INVOICE_CONFIGS = 'GET_CUSTOMER_INVOICE_CONFIGS';
const GET_CUSTOMER_INVOICE_CONFIGS_COMPLETED =
  'GET_CUSTOMER_INVOICE_CONFIGS_COMPLETED';
const GET_CUSTOMER_INVOICE_CONFIGS_FAILED =
  'GET_CUSTOMER_INVOICE_CONFIGS_FAILED';

const GET_INVOICE_CONFIG_DATA = 'GET_INVOICE_CONFIG_DATA';
const GET_INVOICE_CONFIG_DATA_COMPLETED = 'GET_INVOICE_CONFIG_DATA_COMPLETED';
const GET_INVOICE_CONFIG_DATA_FAILED = 'GET_INVOICE_CONFIG_DATA_FAILED';

const FETCH_INVOICE_TEMPLATE_CONTENT_OPTIONS =
  'FETCH_INVOICE_TEMPLATE_CONTENT_OPTIONS';
const FETCH_INVOICE_TEMPLATE_CONTENT_OPTIONS_COMPLETED =
  'FETCH_INVOICE_TEMPLATE_CONTENT_OPTIONS_COMPLETED';
const FETCH_INVOICE_TEMPLATE_CONTENT_OPTIONS_FAILED =
  'FETCH_INVOICE_TEMPLATE_CONTENT_OPTIONS_FAILED';

export const addCustomerInvoiceConfig = (requestData) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: ADD_CUSTOMER_INVOICE_CONFIG});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Revenue.addCustomerInvoiceConfigURL(),
        data: {...requestData},
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({type: ADD_CUSTOMER_INVOICE_CONFIG_COMPLETED, payload: data});
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: ADD_CUSTOMER_INVOICE_CONFIG_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: ADD_CUSTOMER_INVOICE_CONFIG_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const fetchInitialInvoiceCustomers = (search) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: FETCH_INITIAL_INVOICE_CUSTOMERS});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: Revenue.fetchInitialInvoiceCustomersURL(search),
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: FETCH_INITIAL_INVOICE_CUSTOMERS_COMPLETED,
          payload: data,
        });
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: FETCH_INITIAL_INVOICE_CUSTOMERS_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: FETCH_INITIAL_INVOICE_CUSTOMERS_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const getCustomerInvoiceConfigs = (customerId) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: GET_CUSTOMER_INVOICE_CONFIGS});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: Revenue.getCustomerInvoiceConfigsURL(customerId),
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({type: GET_CUSTOMER_INVOICE_CONFIGS_COMPLETED, payload: data});
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: GET_CUSTOMER_INVOICE_CONFIGS_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: GET_CUSTOMER_INVOICE_CONFIGS_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const getInvoiceConfigData = (invoiceId) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: GET_INVOICE_CONFIG_DATA});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: Revenue.getInvoiceConfigDataURL(invoiceId),
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({type: GET_INVOICE_CONFIG_DATA_COMPLETED, payload: data});
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: GET_INVOICE_CONFIG_DATA_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: GET_INVOICE_CONFIG_DATA_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const fetchInvoiceTemplateContentOptions = (invoiceId) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: FETCH_INVOICE_TEMPLATE_CONTENT_OPTIONS});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: Revenue.fetchInvoiceTemplateContentOptionsURL(invoiceId),
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: FETCH_INVOICE_TEMPLATE_CONTENT_OPTIONS_COMPLETED,
          payload: data,
        });
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: FETCH_INVOICE_TEMPLATE_CONTENT_OPTIONS_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: FETCH_INVOICE_TEMPLATE_CONTENT_OPTIONS_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};
export default (state = INITIAL_STATE, action) => {
  const {type, payload} = action || {};
  switch (type) {
    case ADD_CUSTOMER_INVOICE_CONFIG:
      return {...state, addingConfig: true};
    case ADD_CUSTOMER_INVOICE_CONFIG_COMPLETED:
      return {
        ...state,
        addingConfig: false,
      };
    case ADD_CUSTOMER_INVOICE_CONFIG_FAILED:
      return {...state, addingConfig: false};
    case GET_CUSTOMER_INVOICE_CONFIGS:
      return {...state, fetchingCustomerInvoiceConfigs: true};
    case GET_CUSTOMER_INVOICE_CONFIGS_COMPLETED:
      return {
        ...state,
        fetchingCustomerInvoiceConfigs: false,
      };
    case GET_CUSTOMER_INVOICE_CONFIGS_FAILED:
      return {...state, fetchingCustomerInvoiceConfigs: false};
    default:
      return state;
  }
};
